module.exports = __webpack_public_path__ + "static/fonts/fa-solid-900.b0c47f8.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-solid-900.woff2
// module id = nPHw
// module chunks = 13 14